/**
 * Trainova AI — Hindi (हिन्दी) Locale Dictionary
 */

export const hi: Record<string, string> = {
  // Navigation & Header
  'nav.brand': 'ट्रेनोवा एआई',
  'nav.dashboard': 'डैशबोर्ड',
  'nav.simulations': 'सिमुलेशन',
  'nav.scenarios': 'परिदृश्य',
  'nav.courses': 'पाठ्यक्रम',
  'nav.my_attempts': 'मेरे प्रयास',
  'nav.assessments': 'मूल्यांकन',
  'nav.reports': 'रिपोर्ट',
  'nav.analytics': 'एनालिटिक्स',
  'nav.settings': 'सेटिंग्स',
  'nav.admin_console': 'एडमिन कंसोल',
  'nav.tenant_settings': 'संगठन सेटिंग्स',
  'nav.sign_out': 'साइन आउट',
  'nav.profile': 'प्रोफ़ाइल',
  'nav.language': 'भाषा',
  'nav.menu': 'मेनू',
  'nav.close': 'बंद करें',
  'nav.home': 'होम',
  'nav.my_results': 'मेरे परिणाम',
  'nav.learners': 'शिक्षार्थी',
  'nav.users': 'उपयोगकर्ता',

  // Authentication & Login
  'auth.sign_in': 'साइन इन करें',
  'auth.welcome_back': 'Trainova में साइन इन करें',
  'auth.sign_in_subtitle': 'अपने एआई सिमुलेशन वर्कस्पेस में प्रवेश करें',
  'auth.sign_in_to_org': '{{org}} में साइन इन करें',
  'auth.org_portal_welcome': '{{org}} संगठन पोर्टल में आपका स्वागत है।',
  'auth.single_tenant_workspace': 'एकल-किरायेदार वर्कस्पेस',
  'auth.change_org': 'बदलें',
  'auth.change_org_title': 'डिफ़ॉल्ट लॉगिन पर स्विच करें',
  'auth.locked_by_url': 'यूआरएल द्वारा लॉक किया गया',
  'auth.studio_badge': 'एआई सिमुलेशन स्टूडियो',
  'auth.quick_demo_access': 'त्वरित डेमो एक्सेस',
  'auth.demo_role_selector_aria': 'डेमो भूमिका चयनकर्ता',
  'auth.role_learner': 'शिक्षार्थी',
  'auth.role_admin': 'व्यवस्थापक',
  'auth.role_super_admin': 'सुपर व्यवस्थापक',
  'auth.email_label': 'ईमेल पता / उपयोगकर्ता आईडी',
  'auth.email_placeholder': 'learner@enterprise.com',
  'auth.password_label': 'पासवर्ड',
  'auth.password_placeholder': '••••••••••••',
  'auth.show_password_aria': 'पासवर्ड दिखाएं',
  'auth.hide_password_aria': 'पासवर्ड छुपाएं',
  'auth.tenant_slug_label': 'संगठन स्लग',
  'auth.tenant_slug_placeholder': 'उदा. demo-trainova',
  'auth.remember_me': 'मुझे इस डिवाइस पर साइन इन रखें',
  'auth.forgot_password': 'पासवर्ड भूल गए?',
  'auth.signing_in': 'साइन इन हो रहा है...',
  'auth.submit_sign_in': 'पोर्टल में साइन इन करें',
  'auth.submit_sign_in_to_org': '{{org}} में साइन इन करें',
  'auth.entering_portal': 'Trainova.ai में प्रवेश कर रहे हैं…',
  'auth.bottom_note': 'एंटरप्राइज मूल्यांकन पोर्टल · आपके व्यवस्थापक द्वारा प्रबंधित खाते',
  'auth.switch_account': 'खाता बदलें',
  'auth.logged_in_as': '{{name}} के रूप में लॉगिन',
  'auth.login_error': 'अमान्य ईमेल या पासवर्ड। कृपया पुनः प्रयास करें।',
  'auth.session_expired': 'आपका सत्र समाप्त हो गया है। कृपया पुनः साइन इन करें।',
  'auth.err_required': 'कृपया अपना ईमेल और पासवर्ड दर्ज करें।',
  'auth.err_invalid_credentials': 'अमान्य ईमेल या पासवर्ड। कृपया अपने क्रेडेंशियल्स की जांच करें या ऊपर किसी त्वरित डेमो भूमिका पर क्लिक करें।',
  'auth.err_login_failed': 'लॉगिन विफल रहा। कृपया अपने क्रेडेंशियल्स की जांच करें।',
  'auth.err_unexpected': 'एक अनपेक्षित त्रुटि हुई। कृपया पुनः प्रयास करें।',
  'auth.reset_password_title': 'पासवर्ड रीसेट करें',
  'auth.reset_password_msg': 'पासवर्ड रीसेट निर्देश आपके ईमेल पर भेज दिए गए हैं।',

  // Auth & Branding Panel (.auth-brand)
  'auth.brand_tagline_main': 'बातचीत का अभ्यास करें',
  'auth.brand_tagline_em': 'वास्तविक होने से पहले।',
  'auth.brand_lede': 'एआई व्यक्तित्वों के साथ ग्राहक कॉल्स का पूर्वाभ्यास करें, हर दक्षता पर अंक प्राप्त करें, और साबित करें कि आप तैयार हैं।',
  'auth.brand_sim_who_name': 'प्रिया शर्मा · ग्राहक',
  'auth.brand_sim_who_desc': 'फ़िनटेक · विवादित कार्ड शुल्क · सेवा',
  'auth.brand_sim_live': 'अभ्यास',
  'auth.brand_sim_cust_role': 'ग्राहक',
  'auth.brand_sim_cust_msg': 'मुझसे एक ही ऑर्डर के लिए दो बार शुल्क लिया गया है और तीन दिनों से किसी ने मेरी मदद नहीं की है!',
  'auth.brand_sim_me_role': 'आप (शिक्षार्थी)',
  'auth.brand_sim_me_msg': 'मैं आपकी निराशा समझता हूँ, प्रिया। मुझे दोनों लेनदेन देखने दें और अभी जांच करने दें।',
  'auth.brand_sim_meter_empathy': 'सहानुभूति',
  'auth.brand_sim_meter_resolution': 'समाधान',
  'auth.brand_sim_meter_readiness': 'तैयारी',
  'auth.brand_flow_practice': 'अभ्यास',
  'auth.brand_flow_assess': 'मूल्यांकन',
  'auth.brand_flow_coach': 'कोचिंग',
  'auth.brand_flow_prove': 'तैयारी साबित करें',

  // Auth Layout Topline & Footer
  'auth.org_logo_alt': 'संगठन का लोगो',
  'auth.footer_copyright': '© 2026 Trainova AI Inc.',
  'auth.footer_privacy': 'गोपनीयता नीति',
  'auth.footer_terms': 'सेवा की शर्तें',
  'auth.footer_support': 'सहायता',

  // Login Gateway Transition
  'gateway.security_auth_title': 'सुरक्षा एवं प्रमाणीकरण',
  'gateway.security_auth_sub': 'सत्र टोकन सत्यापित कर रहे हैं',
  'gateway.tenant_gateway_title': 'किरायेदार गेटवे',
  'gateway.tenant_gateway_sub_workspace': '{{tenant}} वर्कस्पेस',
  'gateway.tenant_gateway_sub_default': 'एंटरप्राइज किरायेदार',
  'gateway.ai_core_title': 'एआई व्यक्तित्व कोर',
  'gateway.ai_core_sub': 'सिमुलेशन और मॉडल सिंक हो रहे हैं',
  'gateway.ready_title': 'तैयार',
  'gateway.ready_sub': 'पोर्टल लॉन्च हो रहा है',
  'gateway.welcome_back': 'वापसी पर स्वागत है, {{name}}!',
  'gateway.entering_portal': 'पोर्टल में प्रवेश कर रहे हैं…',
  'gateway.status_authenticating': 'सत्र प्रमाणित किया जा रहा है…',
  'gateway.status_connecting': 'वर्कस्पेस से जुड़ रहे हैं…',
  'gateway.status_preparing': 'एआई सिमुलेशन इंजन लोड हो रहे हैं…',
  'gateway.status_ready': 'तैयार! डैशबोर्ड लॉन्च हो रहा है…',

  // Dashboard
  'dashboard.greeting': 'वापसी पर स्वागत है, {{name}}',
  'dashboard.subtitle': 'यथार्थवादी एआई व्यक्तित्वों के साथ उच्च-स्तरीय बातचीत का अभ्यास करें।',
  'dashboard.assigned_simulations': 'निर्दिष्ट सिमुलेशन',
  'dashboard.practice_simulations': 'अभ्यास एवं अन्वेषण परिदृश्य',
  'dashboard.recent_attempts': 'हाल के प्रयास',
  'dashboard.stats_completed': 'पूर्ण सिमुलेशन',
  'dashboard.stats_avg_score': 'औसत स्कोर',
  'dashboard.stats_hours_practiced': 'अभ्यास समय',
  'dashboard.stats_readiness': 'भूमिका तत्परता',
  'dashboard.view_all': 'सभी देखें',
  'dashboard.start_simulation': 'सिमुलेशन शुरू करें',
  'dashboard.resume_attempt': 'प्रयास जारी रखें',
  'dashboard.view_results': 'परिणाम देखें',
  'dashboard.no_assigned': 'इस समय कोई सिमुलेशन आवंटित नहीं है।',
  'dashboard.no_attempts': 'अभी तक कोई सिमुलेशन प्रयास रिकॉर्ड नहीं हुआ है।',

  // Scenario Briefing & System Check
  'briefing.title': 'परिदृश्य विवरण',
  'briefing.overview': 'संदर्भ एवं स्थिति',
  'briefing.objectives': 'सीखने के उद्देश्य एवं दक्षताएँ',
  'briefing.persona': 'एआई व्यक्तित्व जानकारी',
  'briefing.role': 'व्यक्तित्व भूमिका',
  'briefing.temperament': 'स्वभाव एवं व्यवहार',
  'briefing.hardware_check': 'हार्डवेयर तत्परता जांच',
  'briefing.mic_status': 'माइक्रोफ़ोन',
  'briefing.camera_status': 'कैमरा (वैकल्पिक)',
  'briefing.audio_status': 'स्पीकर ऑडियो',
  'briefing.testing_mic': 'वॉल्यूम जांचने के लिए माइक्रोफ़ोन में बोलें...',
  'briefing.mic_ready': 'माइक्रोफ़ोन सक्रिय और तैयार है',
  'briefing.mic_permission_needed': 'आगे बढ़ने के लिए माइक्रोफ़ोन अनुमति आवश्यक है',
  'briefing.allow_mic': 'माइक्रोफ़ोन एक्सेस की अनुमति दें',
  'briefing.retry_mic': 'माइक्रोफ़ोन पुनः जांचें',
  'briefing.consent_title': 'रिकॉर्डिंग एवं एआई मूल्यांकन सहमति',
  'briefing.consent_body': 'स्वचालित मूल्यांकन और प्रशिक्षक विश्लेषण के लिए यह सत्र रिकॉर्ड और ट्रांसक्राइब किया जाएगा। आपका डेटा आपके संगठन के भीतर सुरक्षित रहेगा।',
  'briefing.consent_checkbox': 'मैं सत्र रिकॉर्डिंग और एआई-संचालित मूल्यांकन की सहमति देता हूँ।',
  'briefing.start_simulation_btn': 'सिमुलेशन रूम में प्रवेश करें',
  'briefing.preparing_room': 'एआई व्यक्तित्व और ऑडियो स्टेज तैयार किया जा रहा है...',

  // Simulation Room & Conversation Controls
  'simulation.live_title': 'लाइव एआई सिमुलेशन सत्र',
  'simulation.persona_speaking': 'एआई व्यक्तित्व बोल रहा है...',
  'simulation.listening_user': 'आपको सुन रहे हैं... स्वाभाविक रूप से बोलें',
  'simulation.connecting': 'सुरक्षित ऑडियो स्ट्रीम स्थापित की जा रही है...',
  'simulation.paused': 'सिमुलेशन रुका हुआ है',
  'simulation.mute_mic': 'माइक म्यूट करें',
  'simulation.unmute_mic': 'माइक अनम्यूट करें',
  'simulation.finish_session': 'सत्र पूरा करें',
  'simulation.retry': 'सिमुलेशन पुनः प्रयास करें',
  'simulation.turn_count': 'टर्न {{current}}',
  'simulation.timer': 'सत्र समय',
  'simulation.transcript_title': 'रीयल-टाइम बातचीत ट्रांसक्रिप्ट',
  'simulation.transcript_empty': 'जैसे ही आप बोलेंगे, बातचीत यहां दिखाई देगी।',
  'simulation.confirm_finish_title': 'क्या सिमुलेशन समाप्त और सबमिट करें?',
  'simulation.confirm_finish_body': 'क्या आप वाकई इस सिमुलेशन को समाप्त करना चाहते हैं? आपकी बातचीत तुरंत मूल्यांकन के लिए भेजी जाएगी।',
  'simulation.confirm_cancel': 'सिमुलेशन जारी रखें',
  'simulation.confirm_submit': 'मूल्यांकन के लिए सबमिट करें',
  'simulation.evaluating_title': 'बातचीत के प्रदर्शन का मूल्यांकन हो रहा है...',
  'simulation.evaluating_subtitle': 'सहानुभूति, समस्या समाधान, नियामक अनुपालन और आपत्ति प्रबंधन का विश्लेषण जारी है।',

  // Autoplay & Voice Interaction Alerts
  'simulation.autoplay_blocked_banner': 'एआई की आवाज़ सुनने के लिए कहीं भी क्लिक करें या आवाज़ चलाएँ पर टैप करें',
  'simulation.play_audio_btn': 'आवाज़ चलाएँ',

  // Microphone & Hardware Alerts in Simulation
  'simulation.mic_blocked_title': 'माइक्रोफ़ोन एक्सेस अवरुद्ध है',
  'simulation.mic_blocked_banner': 'माइक्रोफ़ोन एक्सेस आपके ब्राउज़र द्वारा अवरुद्ध है। एड्रेस बार में 🔒 या सेटिंग्स आइकन पर क्लिक करके अनुमति दें, या जारी रखने के लिए टेक्स्ट मोड चुनें।',
  'simulation.mic_blocked_help': 'अनुमति देने के लिए: अपने ब्राउज़र के एड्रेस बार में URL के बगल में 🔒 या 🎛️ आइकन पर क्लिक करें, माइक्रोफ़ोन को "अनुमति दें (Allow)" पर सेट करें और फिर "पुनः प्रयास करें" दबाएँ।',
  'simulation.mic_help_btn': 'ℹ️ अनुमति कैसे दें?',
  'simulation.retry_mic': 'माइक पुनः प्रयास करें',
  'simulation.use_text_mode': 'टेक्स्ट मोड का उपयोग करें',
  'simulation.text_mode_active': 'टेक्स्ट मोड सक्रिय — नीचे अपना उत्तर टाइप करें',
  'simulation.text_input_placeholder': 'यहाँ अपना उत्तर लिखें और Enter दबाएँ...',
  'simulation.text_input_ai_speaking': '{{name}} बोल रहे हैं...',
  'simulation.text_input_ai_thinking': 'एआई विश्लेषण कर रहा है...',
  'simulation.text_send': 'भेजें',
  'simulation.switch_to_voice': 'ध्वनि मोड पर वापस जाएं',
  'simulation.mic_live': 'सक्रिय',
  'simulation.mic_muted': 'म्यूट',
  'simulation.camera_live': 'चालू',
  'simulation.camera_off': 'बंद',
  'simulation.auto_saved_long': 'स्वतः सहेजा गया · डिस्कनेक्ट होने पर पुनः शुरू करें',
  'simulation.auto_saved_short': 'स्वतः सहेजा गया',
  'simulation.attempt_progress': '{{category}} · प्रयास {{current}} / {{max}}',
  'simulation.rec_badge': 'रिकॉर्ड',
  'simulation.init_badge': 'प्रारंभ',
  'simulation.nocam_badge': 'कैमरा बंद',
  'simulation.time_left': 'शेष समय',
  'simulation.elapsed': 'बीता समय',
  'simulation.stage_label': 'चरण',
  'simulation.stage_progress': 'चरण {{current}} / {{total}} · {{name}}',
  'simulation.live_llm_trace': 'लाइव एलएलएम ट्रेस',
  'simulation.inspect_trace_tooltip': 'रीयल-टाइम एलएलएम एपीआई कॉल, प्रॉम्प्ट और संवाद स्थिति का निरीक्षण करें',
  'simulation.audio_error_desc': 'यदि उपलब्ध हो तो वॉयस सिंथेसिस का उपयोग किया जाएगा, या आप नीचे पुनः प्रयास कर सकते हैं।',
  'simulation.retry_audio': 'ऑडियो पुनः प्रयास करें',
  'simulation.buffering_audio': 'ऑडियो बफ़र हो रहा है…',
  'simulation.persona_thinking': 'सोच रहे हैं...',
  'simulation.repeat': 'दोहराएं',
  'simulation.repeat_persona_tooltip': '{{name}} का अंतिम उत्तर दोहराएं',
  'simulation.ai_voice_chip': 'एआई आवाज़',
  'simulation.ai_voice_tooltip': 'यह आवाज़ एआई द्वारा जनरेट की गई है',
  'simulation.camera_off_overlay': 'कैमरा बंद',
  'simulation.speaking_badge': 'बोल रहे हैं',
  'simulation.you_label': 'आप',
  'simulation.scenario_heading': 'परिदृश्य',
  'simulation.scenario_hide_tip': 'विवरण छिपाने के लिए क्लिक करें',
  'simulation.scenario_view_tip': 'पूर्ण परिदृश्य विवरण देखने के लिए क्लिक करें',
  'simulation.hide': 'छिपाएं',
  'simulation.show': 'दिखाएं',
  'simulation.your_objective': 'आपका उद्देश्य',
  'simulation.scenario_personas': 'परिदृश्य के पात्र',
  'simulation.live_transcript': 'लाइव प्रतिलेख',
  'simulation.live_badge': 'लाइव',
  'simulation.transcript_listening': 'बातचीत शुरू होने की प्रतीक्षा की जा रही है...',
  'simulation.role_learner': 'शिक्षार्थी',
  'simulation.role_ai_prefix': 'एआई · {{role}}',
  'simulation.repeat_message_tooltip': 'इस संदेश को दोहराएं',
  'simulation.participants_single': '1 एआई एजेंट ({{name}}) + आप',
  'simulation.participants_multiple': '{{count}} एआई पात्र + आप',
  'simulation.toggle_mic_tooltip': 'माइक्रोफ़ोन चालू/बंद करें',
  'simulation.toggle_camera_tooltip': 'कैमरा चालू/बंद करें',
  'simulation.camera_on': 'कैमरा चालू',
  'simulation.cam_on_short': 'कैम चालू',
  'simulation.cam_off_short': 'कैम बंद',
  'simulation.repeat_last_tooltip': 'अंतिम संदेश दोहराएं',
  'simulation.repeat_last': 'अंतिम दोहराएं',
  'simulation.transcript_tooltip': 'पूर्ण बातचीत प्रतिलेख देखें',
  'simulation.transcript': 'प्रतिलेख',
  'simulation.end_assessment_tooltip': 'मूल्यांकन समाप्त करें',
  'simulation.end_assessment': 'मूल्यांकन समाप्त',
  'simulation.end_short': 'समाप्त',
  'simulation.end_modal_title': 'क्या यह सिमुलेशन समाप्त करें?',
  'simulation.end_modal_desc': 'आपका ऑडियो, वीडियो और प्रतिलेख स्कोरिंग और फीडबैक के लिए सबमिट किया जाएगा। आप इस प्रयास को पुनः जारी नहीं रख पाएंगे।',
  'simulation.end_modal_time_elapsed': 'बीता समय',
  'simulation.end_modal_turns_recorded': 'दर्ज किए गए टर्न',
  'simulation.end_modal_turns_count': '{{count}} टर्न',
  'simulation.end_modal_continue': 'सिमुलेशन जारी रखें',
  'simulation.end_modal_submit': 'समाप्त करें और सबमिट करें',
  'simulation.turn_ended_complete_title': 'बातचीत पूर्ण हुई',
  'simulation.turn_ended_limit_title': 'टर्न की सीमा समाप्त',
  'simulation.turn_ended_desc': 'समीक्षा करें और स्कोर रिपोर्ट पर आगे बढ़ें',
  'simulation.turn_ended_view_report': 'स्कोर रिपोर्ट देखें',
  'simulation.trace_modal_title': 'एलएलएम एपीआई कॉल, प्रॉम्प्ट और संवाद स्थिति का निरीक्षण करें',
  'simulation.trace_modal_close': 'बंद करें',
  'simulation.dismiss_banner': 'बैनर हटाएँ',
  'simulation.role_ai': 'एआई',
  'simulation.mic_permission_help_title': 'माइक्रोफ़ोन अनुमति सहायता',
  'simulation.switch_to_voice_title': 'पुनः वॉइस मोड पर स्विच करें',
  'simulation.privacy_video_notice': 'सभी विश्लेषण आपके ब्राउज़र में 100% स्थानीय रूप से संसाधित होते हैं। वीडियो कभी सर्वर पर नहीं भेजा जाता।',
  'simulation.live_learner_speaking': 'बोल रहे हैं...',
  'simulation.ready_to_begin': 'संवाद शुरू करने के लिए तैयार',
  'simulation.ready_to_begin_desc': 'अपने माइक्रोफ़ोन के माध्यम से बोलें या नीचे दिए गए त्वरित इनपुट बॉक्स में उत्तर लिखें।',
  'simulation.replay': 'पुनः सुनें',
  'simulation.return_to_stage': 'सिमुलेशन स्टेज पर वापस जाएं',
  'simulation.trace_session_attempt': 'सत्र प्रयास',
  'simulation.trace_target_persona': 'लक्षित व्यक्तित्व',
  'simulation.trace_stage_progression': 'चरण प्रगति',
  'simulation.trace_language_turns': 'भाषा और राउंड',
  'simulation.trace_turns_count': '{{count}} राउंड',
  'simulation.trace_live_exchange_log': 'लाइव टर्न एक्सचेंज लॉग ({{count}} राउंड)',
  'simulation.trace_realtime_stream': 'रीयल-टाइम संवाद स्ट्रीम',
  'simulation.trace_no_turns': 'अभी तक कोई राउंड संसाधित नहीं हुआ है। संवाद शुरू करने के लिए बोलें या अभिवादन लिखें।',
  'simulation.submit_response': 'प्रतिक्रिया सबमिट करें',
  'simulation.auto_submitting_in': '{{seconds}} सेकंड में ऑटो-सबमिट हो रहा है…',
  'simulation.speak_to_continue': 'बोलना जारी रखें या अभी सबमिट करें',
  'simulation.submitting_countdown': '{{seconds}} सेकंड में सबमिट हो रहा है',

  // Simulation Completion & Results Generation Popup
  'simulation.eval_overlay_title': 'परिणामों का विश्लेषण और तैयारी',
  'simulation.eval_overlay_desc': 'आपका सिमुलेशन समाप्त हो गया है। Trainova का बहु-आयामी मूल्यांकन इंजन संवाद के चरणों का विश्लेषण कर रहा है, दक्षताओं का मूल्यांकन कर रहा है, और आपका व्यापक स्कोरकार्ड तैयार कर रहा है...',
  'simulation.eval_mic_video_stopped': 'माइक्रोफ़ोन और वीडियो कैप्चर बंद किया गया',
  'simulation.eval_mic_stopped': 'माइक्रोफ़ोन कैप्चर बंद किया गया',
  'simulation.eval_transcript_captured': 'सत्र प्रतिलेख सहेजा गया ({{count}} मोड़)',
  'simulation.eval_generating_scorecard': 'रूब्रिक मूल्यांकन और व्यवहारिक स्कोरकार्ड तैयार किया जा रहा है...',
  'simulation.eval_stuck_desc': 'इसमें सामान्य से अधिक समय लग रहा है। आप यहाँ प्रतीक्षा कर सकते हैं, या प्रयास खोल सकते हैं और इसके समाप्त होने पर स्कोरकार्ड पढ़ सकते हैं।',
  'simulation.eval_open_attempt_btn': 'मेरा प्रयास खोलें →',

  // Simulation Completion Banner & Dialogue End Modals
  'simulation.turns_completed_summary': 'सिमुलेशन संवाद समाप्त हुआ ({{count}} मोड़)।',
  'simulation.ready_for_debrief': 'मूल्यांकन समीक्षा के लिए तैयार।',
  'simulation.turn_ended_limit_desc': 'आप इस सिमुलेशन के लिए अधिकतम अनुमत संवाद मोड़ों ({{max}} में से {{current}} मोड़) तक पहुँच गए हैं।',
  'simulation.turn_ended_concluded_desc': 'आपके संवाद साथी ने बातचीत समाप्त कर दी है ({{count}} मोड़ दर्ज किए गए)।',

  // Room Initialization Screen & Readiness Stepper
  'simulation.initializing_room_title': 'सिमुलेशन कक्ष प्रारंभ हो रहा है...',
  'simulation.init_slow_desc': 'AI रोलप्ले इंजन से कनेक्ट होने में सामान्य से अधिक समय लग रहा है। आप थोड़ी देर प्रतीक्षा कर सकते हैं या पुनः कनेक्ट कर सकते हैं।',
  'simulation.init_loading_desc': 'परिदृश्य ब्रीफिंग, व्यक्तित्व निर्देश और संवाद लोड किया जा रहा है।',
  'simulation.init_briefing_loaded': 'परिदृश्य ब्रीफिंग और व्यक्तित्व निर्देश',
  'simulation.init_dialogue_connected': 'संवाद इंजन कनेक्ट हुआ',
  'simulation.init_mic_ready': 'माइक्रोफ़ोन संवाद के लिए तैयार',
  'simulation.init_audio_loaded': 'आवश्यक ऑडियो संसाधन लोड और डिकोड किए गए',
  'simulation.init_ready': 'तैयार',
  'simulation.init_waiting': 'प्रतीक्षारत',
  'simulation.mic_blocked_init_title': 'माइक्रोफ़ोन एक्सेस अवरुद्ध है',
  'simulation.mic_blocked_init_desc': 'अपने ब्राउज़र के एड्रेस बार में माइक्रोफ़ोन एक्सेस की अनुमति दें, फिर पुनः प्रयास करें। यदि कोई प्रॉम्प्ट दिखाई नहीं देता है, तो यह ब्राउज़र या कनेक्शन माइक्रोफ़ोन कैप्चर का समर्थन नहीं कर सकता है — कक्ष अभी भी टाइप किए गए उत्तरों के साथ खुल सकता है।',
  'simulation.requesting_access': 'एक्सेस का अनुरोध किया जा रहा है…',
  'simulation.retry_mic_init': 'माइक्रोफ़ोन पुनः प्रयास करें',
  'simulation.mic_checking_desc': 'यदि आपका ब्राउज़र पूछे तो माइक्रोफ़ोन एक्सेस की अनुमति दें — कक्ष खुलते ही आप बोल सकते हैं।',
  'simulation.reconnect_room': 'कक्ष पुनः कनेक्ट करें',
  'simulation.back_to_briefing': 'ब्रीफिंग पर वापस जाएं',
  'simulation.exit_to_briefing': 'ब्रीफिंग पर बाहर निकलें',
  'simulation.unable_to_start': 'सिमुलेशन प्रारंभ करने में असमर्थ',

  // Role & Mood Lookups
  'role.customer': 'ग्राहक',
  'role.client': 'ग्राहक',
  'role.manager': 'प्रबंधक',
  'role.colleague': 'सहकर्मी',
  'role.learner': 'शिक्षार्थी',
  'mood.irritated_polite': 'थोड़े चिढ़े हुए लेकिन विनम्र',
  'mood.frustrated': 'हताश',
  'mood.satisfied': 'संतुष्ट',
  'mood.neutral': 'तटस्थ',
  'mood.anxious': 'चिंतित',
  'mood.demanding': 'मांग करने वाले',

  // Evaluation Scorecard & Results
  'scorecard.title': 'मूल्यांकन स्कोरकार्ड',
  'scorecard.overall_score': 'समग्र प्रदर्शन स्कोर',
  'scorecard.passing_score': 'उत्तीर्ण मानक: {{score}}%',
  'scorecard.status_passed': 'सफल (Passed)',
  'scorecard.status_failed': 'सुधार की आवश्यकता',
  'scorecard.status_in_progress': 'मूल्यांकन जारी',
  'scorecard.competencies_title': 'मूल्यांकित मुख्य दक्षताएँ',
  'scorecard.key_strengths': 'प्रमुख ताकतें',
  'scorecard.areas_for_growth': 'सुधार के लक्षित क्षेत्र',
  'scorecard.actionable_recommendations': 'व्यावहारिक कोचिंग सुझाव',
  'scorecard.evidence_quotes': 'ट्रांसक्रिप्ट से सटीक उद्धरण',
  'scorecard.replay_recording': 'मूल्यांकन सत्र रिकॉर्डिंग एवं रीप्ले',
  'scorecard.download_report': 'पीडीएफ रिपोर्ट डाउनलोड करें',
  'scorecard.retry_btn': 'सिमुलेशन पुनः करें',
  'scorecard.back_dashboard': 'डैशबोर्ड पर वापस जाएं',
  'scorecard.retake_simulation': 'सिमुलेशन पुनः करें',
  'scorecard.reevaluate_openai': 'OpenAI से पुनः मूल्यांकन करें',
  'scorecard.evaluating_action': 'मूल्यांकन हो रहा है...',
  'scorecard.practice_similar': 'समान परिदृश्य का अभ्यास करें',
  'scorecard.download_json': 'रिपोर्ट JSON डाउनलोड करें',
  'scorecard.inspect_prompts': 'एलएलएम प्रॉम्प्ट देखें',
  'scorecard.attempt_counter': 'प्रयास {{current}} / {{max}}',
  'scorecard.target_passing_score': 'लक्ष्य उत्तीर्ण स्कोर: {{score}}%',
  'scorecard.role_label': 'भूमिका:',
  'scorecard.persona_label': 'पात्र:',
  'scorecard.scorecard_title_suffix': 'स्कोरकार्ड',
  'scorecard.badge_passed': 'सफल (Passed)',
  'scorecard.badge_needs_review': 'समीक्षा आवश्यक',
  'scorecard.badge_completed': 'पूर्ण हुआ',
  'scorecard.badge_ai_eval': 'एआई मूल्यांकन',
  'scorecard.all_attempts_btn': '‹ सभी प्रयास',
  'scorecard.analyzing_attempt': 'प्रयास के प्रदर्शन का विश्लेषण हो रहा है...',
  'scorecard.evaluating_subtext': 'भाषण शैली, बातचीत रूब्रिक्स और व्यावहारिक कोचिंग फीडबैक का मूल्यांकन किया जा रहा है।',
  'scorecard.in_progress_title': 'प्रयास प्रगति पर है',
  'scorecard.in_progress_desc': 'यह सिमुलेशन प्रयास अभी तक मूल्यांकन के लिए सबमिट नहीं किया गया है। आप सत्र फिर से शुरू कर सकते हैं, या रिपोर्ट जनरेट करने के लिए इसे अभी सबमिट कर सकते हैं।',
  'scorecard.resume_simulation': 'सिमुलेशन पुनः शुरू करें',
  'scorecard.end_and_submit': 'समाप्त करें और मूल्यांकन के लिए सबमिट करें',
  'scorecard.submitting_evaluating': 'सबमिट और मूल्यांकन हो रहा है...',
  'scorecard.my_attempts': 'मेरे प्रयास',
  'scorecard.assessment_completed_title': 'मूल्यांकन पूरा हुआ',
  'scorecard.session_recording_title': 'आपकी सत्र रिकॉर्डिंग',
  'scorecard.dashboard_btn': 'डैशबोर्ड',
  'scorecard.overall_score_label': 'समग्र स्कोर',
  'scorecard.below_target': 'लक्ष्य से नीचे',
  'scorecard.target_achieved': 'लक्ष्य प्राप्त किया',
  'scorecard.pass_mark_desc': 'उत्तीर्ण मानक {{score}}% है। नीचे कोचिंग फीडबैक की समीक्षा करें और तैयारी प्राप्त करने के लिए अगला प्रयास शुरू करें।',
  'scorecard.readiness_label': 'तैयारी',
  'scorecard.target_label': 'लक्ष्य',
  'scorecard.time_taken_label': 'लिया गया समय',
  'scorecard.of_time': '{{time}} में से',
  'scorecard.stages_completed_label': 'पूर्ण किए गए चरण',
  'scorecard.stages_of': '{{current}} / {{total}}',
  'scorecard.all_stages_reached': 'बातचीत के सभी चरण पूरे किए',
  'scorecard.evaluated_label': 'मूल्यांकित',
  'scorecard.overall_feedback_title': 'समग्र फीडबैक',
  'scorecard.ai_summary_reviewed': 'एआई सारांश · कोच द्वारा समीक्षित',
  'scorecard.overall_feedback_empty': 'मूल्यांकन पूरा होने के बाद समग्र फीडबैक यहाँ दिखाई देगा।',
  'scorecard.based_on_rubric': 'रिकॉर्डिंग, प्रतिलेख और आपके संगठन के रूब्रिक पर आधारित।',
  'scorecard.top_strength_tag': 'प्रमुख ताकत',
  'scorecard.biggest_gap_tag': 'सुधार का मुख्य क्षेत्र',
  'scorecard.delivery_tag': 'प्रस्तुति एवं शैली',
  'scorecard.speaking_pace_measured': 'बोलने की गति मापी गई',
  'scorecard.metric_breakdown_empty': 'मूल्यांकन के बाद मेट्रिक विवरण यहाँ दिखाई देगा।',
  'scorecard.competency_breakdown_title': 'दक्षता विवरण',
  'scorecard.scored_against_rubric': 'संगठन के रूब्रिक के अनुसार मूल्यांकित',
  'scorecard.legend_strong': 'उत्कृष्ट (4.0+)',
  'scorecard.legend_ontrack': 'सही दिशा में (3.0 - 3.9)',
  'scorecard.legend_needswork': 'सुधार आवश्यक (3.0 से कम)',
  'scorecard.no_competencies_evaluated': 'इस सत्र के लिए किसी भी दक्षता रूब्रिक का मूल्यांकन नहीं किया गया था।',
  'scorecard.weight_pct': 'भार {{pct}}%',
  'scorecard.score_calc_traceability': 'स्कोर गणना एवं भार अनुरेखणीयता',
  'scorecard.formula_label': 'सूत्र:',
  'scorecard.table_competency': 'दक्षता',
  'scorecard.table_raw_score': 'मूल स्कोर',
  'scorecard.table_weight': 'भार',
  'scorecard.table_contribution': 'योगदान',
  'scorecard.total_calc_score': 'कुल परिकलित स्कोर:',
  'scorecard.pass_threshold': 'उत्तीर्ण सीमा: {{score}}%',
  'scorecard.evidence_traceability_prefix': 'साक्ष्य अनुरेखणीयता:',
  'scorecard.criterion_not_met': 'बातचीत के दौरान मानदंड पूरा नहीं हुआ।',
  'scorecard.improvement_tips_title': 'सुधार हेतु सुझाव',
  'scorecard.most_impact_first': 'सबसे महत्वपूर्ण पहले',
  'scorecard.improvement_tips_empty': 'एआई मूल्यांकन पूरा होने पर सुधार सुझाव यहाँ दिखाई देंगे।',
  'scorecard.actionable_recommendation_label': 'व्यावहारिक सुझाव:',
  'scorecard.camera_analysis_title': 'कैमरा वीडियो विश्लेषण',
  'scorecard.audio_only_scenario': 'केवल ऑडियो परिदृश्य',
  'scorecard.audio_only_desc': 'यह सिमुलेशन केवल ऑडियो मूल्यांकन के रूप में कॉन्फ़िगर किया गया है। इस परिदृश्य के लिए कैमरा फ़ीड का अनुरोध या रिकॉर्डिंग नहीं की गई थी।',
  'scorecard.assessment_mode_voice': 'मूल्यांकन मोड: केवल ध्वनि',
  'scorecard.scoring_focus_empathy': 'स्कोरिंग फोकस: सहानुभूति, लहजा एवं संवाद',
  'scorecard.privacy_no_camera': 'गोपनीयता: कोई कैमरा फ़ीड रिकॉर्ड नहीं की गई',
  'scorecard.not_recorded': 'रिकॉर्ड नहीं किया गया',
  'scorecard.video_processing': 'वीडियो प्रसंस्करण जारी',
  'scorecard.video_processing_sub': 'कंप्यूटर विज़न विश्लेषण पृष्ठभूमि में चल रहा है। मेट्रिक्स स्वतः अपडेट हो जाएंगे।',
  'scorecard.partial_analysis': 'आंशिक विश्लेषण',
  'scorecard.analysis_completed': 'विश्लेषण पूर्ण',
  'scorecard.cv_observations_sub': 'शिक्षार्थी के कैमरा स्ट्रीम से स्थानीय एआई कंप्यूटर विज़न अवलोकन।',
  'scorecard.face_visible': 'चेहरे की दृश्यता',
  'scorecard.continuous_presence': 'कैमरा फ्रेम में निरंतर उपस्थिति',
  'scorecard.conversation_quality_title': 'बातचीत की गुणवत्ता',
  'scorecard.how_customer_felt_sub': 'पूरी बातचीत में ग्राहक कैसा महसूस कर रहा था',
  'scorecard.sentiment_over_call': 'बातचीत के दौरान ग्राहक की भावनाएं',
  'scorecard.sentiment_satisfied': 'संतुष्ट',
  'scorecard.sentiment_neutral': 'तटस्थ',
  'scorecard.sentiment_upset': 'नाराज',
  'scorecard.start_time': 'आरंभ',
  'scorecard.end_time': 'समाप्त',
  'scorecard.sentiment_data_empty': 'बातचीत के टर्न का मूल्यांकन होने के बाद भावना समयरेखा दिखाई देगी।',
  'scorecard.required_steps_title': 'आवश्यक चरण (अनुपालन)',
  'scorecard.completed_of_total': '{{total}} में से {{done}} पूरे हुए',
  'scorecard.compliance_steps_empty': 'इस परिदृश्य के लिए कोई अनुपालन चरण परिभाषित नहीं थे।',
  'scorecard.step_done': 'पूर्ण',
  'scorecard.step_missed': 'छूटा',
  'scorecard.scroll_to_view_steps': 'सभी {{count}} आवश्यक चरणों को देखने के लिए स्क्रॉल करें',
  'scorecard.coach_comments_title': 'कोच की टिप्पणियाँ',
  'scorecard.comments_count_single': '1 टिप्पणी',
  'scorecard.comments_count_plural': '{{count}} टिप्पणियाँ',
  'scorecard.reply_placeholder': 'कोच की टिप्पणियों का उत्तर दें...',
  'scorecard.reply_btn': 'उत्तर दें',
  'scorecard.evaluation_unavailable': 'मूल्यांकन परिणाम अनुपलब्ध',
  'scorecard.retry_fetch': 'पुनः प्रयास करें',

  // Video & Recording Replay
  'video.session_recording': 'मूल्यांकन सत्र रिकॉर्डिंग',
  'video.learner_cam': 'शिक्षार्थी वीडियो',
  'video.persona_cam': 'एआई व्यक्तित्व वीडियो',
  'video.play': 'चलाएं',
  'video.pause': 'रोकें',
  'video.restart': 'पुनः प्रारंभ करें',
  'video.playback_speed': 'गति',
  'video.recording_unavailable': 'सत्र रिकॉर्डिंग अभी प्रक्रियाधीन है या उपलब्ध नहीं है।',
  'video.recording_audio_only': 'केवल ऑडियो सत्र',

  // Tenant Admin & Settings
  'admin.languages_title': 'भाषाएँ और क्षेत्रीय सेटिंग्स',
  'admin.languages_subtitle': 'अपने संगठन के लिए समर्थित भाषाएँ, डिफ़ॉल्ट भाषा और अनुवाद विकल्प कॉन्फ़िगर करें।',
  'admin.supported_languages': 'संगठन के लिए सक्षम भाषाएँ',
  'admin.default_language': 'संगठन की डिफ़ॉल्ट भाषा',
  'admin.fallback_language': 'फ़ॉलबैक भाषा',
  'admin.onboarding_language': 'नए शिक्षार्थियों के लिए डिफ़ॉल्ट भाषा',
  'admin.allow_user_selection': 'उपयोगकर्ताओं को अपनी भाषा चुनने की अनुमति दें',
  'admin.allow_user_selection_help': 'सक्षम होने पर, उपयोगकर्ता अपने नेविगेशन बार में भाषा चयनकर्ता देख सकेंगे।',
  'admin.test_preview_title': 'अनुवाद प्रदाता परीक्षण और लाइव पूर्वावलोकन',
  'admin.test_input_label': 'अनुवाद हेतु नमूना पाठ',
  'admin.test_target_label': 'लक्ष्य भाषा',
  'admin.test_run_btn': 'अनुवाद एपीआई का परीक्षण करें',
  'admin.test_result_label': 'अनुवाद परिणाम',
  'admin.save_settings': 'भाषा सेटिंग्स सहेजें',
  'admin.saved_success': 'भाषा सेटिंग्स सफलतापूर्वक सहेजी गईं।',
  'admin.provider_google': 'गूगल क्लाउड अनुवाद प्रदाता (सक्रिय)',
  'admin.provider_cached': 'मल्टी-टेनेंट अनुवाद लेजर में कैश्ड',
  'admin.console_title': 'ट्रेनोवा एआई प्रशासन कंसोल',

  // Navigation Extras
  'nav.group_workspace': 'कार्यक्षेत्र',
  'nav.group_administration': 'प्रशासन',
  'nav.group_account': 'खाता एवं सहायता',
  'nav.learners_users': 'शिक्षार्थी एवं उपयोगकर्ता',
  'nav.organizations': 'संगठन',
  'nav.rubrics': 'मूल्यांकन रूबरिक्स',
  'nav.llm_logs': 'एलएलएम ऑडिट लॉग्स',
  'nav.audit_trail': 'सुरक्षा ऑडिट ट्रेल',

  // Page Titles
  'dashboard.assigned_studio': 'आवंटित सिमुलेशन एवं अभ्यास स्टूडियो',
  'dashboard.search_placeholder': 'परिदृश्य, व्यक्तित्व खोजें...',
  'attempts.title_admin': 'सिमुलेशन प्रयास एवं प्रदर्शन लेजर',
  'attempts.title_learner': 'मेरे सिमुलेशन प्रयास एवं इतिहास',
  'attempts.history_title': 'परिदृश्य प्रयास इतिहास',
  'scenarios.studio_title': 'परिदृश्य एवं सिमुलेशन स्टूडियो',
  'users.directory_title': 'संगठन सदस्य एवं उपयोगकर्ता निर्देशिका',
  'tenants.title': 'प्लेटफ़ॉर्म संगठन एवं टेनेंट्स',
  'audit.title': 'एंटरप्राइज ऑडिट ट्रेल एवं गवर्नेंस लॉग्स',
  'llm_logs.title': 'एलएलएम इंजन लॉग्स एवं मॉडल इन्फेरेंस ऑडिटिंग',
  'reports.title': 'एंटरप्राइज रिपोर्ट्स एवं कोहॉर्ट एनालिटिक्स',
  'analytics.title': 'एनालिटिक्स एवं अभ्यास बुद्धिमत्ता',

  // Breadcrumbs
  'breadcrumb.home': 'होम',
  'breadcrumb.dashboard': 'डैशबोर्ड',
  'breadcrumb.admin': 'प्रशासन',
  'breadcrumb.learner_portal': 'शिक्षार्थी पोर्टल',
  'breadcrumb.administration_console': 'प्रशासन कंसोल',
  'breadcrumb.simulation_attempts': 'सिमुलेशन प्रयास',
  'breadcrumb.my_simulation_attempts': 'मेरे सिमुलेशन प्रयास',
  'breadcrumb.my_attempts': 'मेरे प्रयास',
  'breadcrumb.attempt_history': 'प्रयास इतिहास',
  'breadcrumb.assigned_simulations': 'आवंटित सिमुलेशन',
  'breadcrumb.scenarios_studio': 'परिदृश्य स्टूडियो',
  'breadcrumb.scenarios': 'परिदृश्य',
  'breadcrumb.scenario_details': 'परिदृश्य विवरण',
  'breadcrumb.create_scenario': 'परिदृश्य बनाएं',
  'breadcrumb.edit_scenario': 'परिदृश्य संपादित करें',
  'breadcrumb.user_directory': 'उपयोगकर्ता निर्देशिका',
  'breadcrumb.learners_users': 'शिक्षार्थी एवं उपयोगकर्ता',
  'breadcrumb.client_organizations': 'ग्राहक संगठन',
  'breadcrumb.org_details': 'संगठन विवरण',
  'breadcrumb.evaluation_rubrics': 'मूल्यांकन रूबरिक्स',
  'breadcrumb.evaluation_config': 'मूल्यांकन कॉन्फ़िगरेशन',
  'breadcrumb.evaluation_studio': 'मूल्यांकन स्टूडियो',
  'breadcrumb.reports_analytics': 'रिपोर्ट्स एवं एनालिटिक्स',
  'breadcrumb.reports': 'रिपोर्ट्स',
  'breadcrumb.analytics': 'एनालिटिक्स',
  'breadcrumb.audit_log': 'ऑडिट लॉग',
  'breadcrumb.audit_trail': 'सुरक्षा ऑडिट ट्रेल',
  'breadcrumb.llm_audit_trail': 'एलएलएम ऑडिट ट्रेल',
  'breadcrumb.llm_logs': 'एलएलएम लॉग्स',
  'breadcrumb.tenant_settings': 'संगठन सेटिंग्स',
  'breadcrumb.notifications': 'अधिसूचना सेटिंग्स',
  'breadcrumb.custom_fields': 'कस्टम उपयोगकर्ता फ़ील्ड',
  'breadcrumb.packages': 'पैकेज प्रबंधन',

  // Table Headers & Controls
  'table.simulation': 'सिमुलेशन',
  'table.category': 'श्रेणी',
  'table.status': 'स्थिति',
  'table.time_limit': 'समय सीमा',
  'table.attempts_left': 'शेष प्रयास',
  'table.progress': 'प्रगति',
  'table.actions': 'कार्रवाई',
  'table.member': 'सदस्य',
  'table.emp_id': 'कर्मचारी आईडी',
  'table.designation': 'पद',
  'table.reporting_manager': 'रिपोर्टिंग प्रबंधक',
  'table.team': 'टीम',
  'table.region': 'क्षेत्र',
  'table.role': 'भूमिका',
  'table.attempt_num': 'प्रयास #',
  'table.started': 'प्रारंभ',
  'table.duration': 'अवधि',
  'table.turns': 'राउंड',
  'table.score': 'अंक',
  'table.ai_persona': 'एआई व्यक्तित्व',
  'table.difficulty': 'कठिनाई स्तर',
  'table.scenario': 'परिदृश्य',
  'table.organization': 'संगठन',
  'table.slug': 'स्लग',
  'table.users': 'उपयोगकर्ता',
  'table.scenarios': 'परिदृश्य',
  'table.attempts': 'प्रयास',
  'table.created': 'निर्मित',
  'table.timestamp': 'समय',
  'table.action': 'कार्रवाई',
  'table.actor': 'कर्ता',
  'table.target': 'लक्ष्य',
  'table.origin_ip': 'मूल / आईपी',
  'table.payload': 'पेलोड',
  'table.no_records': 'कोई रिकॉर्ड नहीं मिला',
  'table.no_attempts': 'कोई प्रयास नहीं मिला',
  'table.no_attempts_desc': 'इस परिदृश्य के लिए अभी तक कोई प्रयास दर्ज नहीं किया गया है।',
  'table.no_users': 'कोई मेल खाते उपयोगकर्ता नहीं मिले।',
  'table.no_orgs': 'कोई संगठन नहीं मिला',
  'table.no_orgs_desc': 'अपनी खोज या फ़िल्टर बदलकर पुनः प्रयास करें।',
  'table.view_details': 'विवरण देखें',
  'table.filter_all': 'सभी',
  'table.filter_not_started': 'शुरू नहीं हुआ',
  'table.filter_in_progress': 'प्रगति पर',
  'table.filter_completed': 'पूर्ण',
  'table.filter_all_statuses': 'सभी स्थितियाँ',
  'table.filter_all_categories': 'सभी श्रेणियां',
  'table.filter_all_difficulties': 'सभी कठिनाई स्तर',
  'table.published': 'प्रकाशित',
  'table.draft': 'ड्राफ्ट',
  'table.archived': 'संग्रहीत',
  'table.beginner': 'शुरुआती',
  'table.intermediate': 'मध्यम',
  'table.advanced': 'उन्नत',
  'table.sort_latest': 'क्रमबद्ध: नवीनतम',
  'table.sort_title': 'क्रमबद्ध: शीर्षक',
  'table.sort_duration': 'क्रमबद्ध: अवधि',

  // Badges
  'badge.enterprise_control_plane': 'एंटरप्राइज कंट्रोल प्लेन',
  'badge.roleplay_hub': 'रोलप्ले हब',
  'badge.practice_ledger': 'अभ्यास लेजर',
  'badge.admin_practice_ledger': 'प्रशासन अभ्यास लेजर',
  'badge.simulation_authoring': 'सिमुलेशन ऑथरिंग',
  'badge.access_governance': 'एक्सेस एवं गवर्नेंस',
  'badge.multi_tenant_master': 'मल्टी-टेनेंट मास्टर',
  'badge.evaluation_governance': 'मूल्यांकन गवर्नेंस',
  'badge.executive_intelligence': 'कार्यकारी बुद्धिमत्ता',
  'badge.security_compliance': 'सुरक्षा एवं अनुपालन',
  'badge.ai_observability': 'एआई ऑब्जर्वेबिलिटी',

  // Common UI Actions & Statuses
  'common.save': 'सहेजें',
  'common.cancel': 'रद्द करें',
  'common.close': 'बंद करें',
  'common.delete': 'हटाएं',
  'common.edit': 'संपादित करें',
  'common.loading': 'लोड हो रहा है...',
  'common.loading_records': 'इतिहास रिकॉर्ड लोड हो रहे हैं…',
  'common.submitting': 'सबमिट हो रहा है...',
  'common.error': 'एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।',
  'common.retry': 'पुनः प्रयास करें',
  'common.success': 'सफल',
  'common.status': 'स्थिति',
  'common.active': 'सक्रिय',
  'common.disabled': 'अक्षम',
  'common.optional': 'वैकल्पिक',
  'common.required': 'अनिवार्य',
  'common.offline_notice': 'आप अभी ऑफ़लाइन हैं। कैश्ड डेटा और स्थानीय भाषा संसाधन दिखाए जा रहे हैं।',
  'common.learn_more': 'और जानें',
  'common.back': 'वापस',

  // Hero Descriptions
  'desc.select_scenario': 'अपनी संवादात्मक भूमिका निभाने का अभ्यास शुरू या जारी रखने के लिए एक परिदृश्य चुनें',
  'desc.attempts_admin': 'संगठनों में शिक्षार्थी सिमुलेशन की निगरानी करें, स्कोरकार्ड का निरीक्षण करें और अभ्यास परिणामों का ऑडिट करें।',
  'desc.attempts_learner': 'अपने सिमुलेशन सत्र ट्रैक करें, सक्रिय परिदृश्य फिर से शुरू करें और पिछले स्कोरकार्ड की समीक्षा करें।',
  'desc.scenarios': 'संवादात्मक एआई सिमुलेशन, ग्राहक व्यक्तित्व और मूल्यांकन रूब्रिक्स बनाएं, परीक्षण करें और प्रकाशित करें।',
  'desc.tenants': 'ग्राहक संगठनों का केंद्रीकृत प्रबंधन, टेनेंट प्रोविजनिंग और प्लेटफॉर्म गवर्नेंस।',
  'desc.users': 'शिक्षार्थी खातों का प्रबंधन करें, प्रशिक्षक व प्रबंधक अनुमतियां असाइन करें और समूहों की देखरेख करें।',
  'desc.audit': 'अपरिवर्तनीय अनुपालन घटनाओं, प्रशासनिक परिवर्तनों और प्रमाणीकरण इतिहास का निरीक्षण करें।',
  'desc.llm_audit': 'एलएलएम प्रॉम्प्ट, टोकन खपत, मॉडल विलंबता, लागत और पेलोड का ऑडिट करें।',
  'desc.reports': 'संगठन पास दर, योग्यता बेंचमार्क बार, शिक्षार्थी मेट्रिक्स और डेटा डंप की समीक्षा करें।',
  'desc.analytics': 'वास्तविक समय सिमुलेशन पूर्णता मेट्रिक्स, योग्यता पास दर और बहु-टेनेंट प्रदर्शन।',
  'desc.admin_dashboard': 'सिस्टम-व्यापी गवर्नेंस, टेनेंट प्रशासन, प्रशिक्षण मेट्रिक्स और एआई सिमुलेशन स्टूडियो।',
  'desc.llm_config': 'संवाद एलएलएम, स्कोरिंग इंजन, वॉइस मॉडल और एन्क्रिप्टेड एपीआई कुंजियां कॉन्फ़िगर करें।',
  'desc.udf_settings': 'शिक्षार्थी मेटाडेटा फ़ील्ड्स (क्षेत्र, लागत केंद्र, बीयू), सीएसवी नियम और एपीआई मैपिंग कॉन्फ़िगर करें।',
  'desc.eval_config': 'मूल्यांकन रूब्रिक्स, स्कोरिंग प्रॉम्प्ट, गोल्डन सेट कैलिब्रेशन और प्रकाशन जीवनचक्र कॉन्फ़िगर करें।',

  // Dashboard Stats & Cards
  'dashboard.stats.total_simulations': 'कुल सिमुलेशन',
  'dashboard.stats.in_progress': 'प्रगति पर',
  'dashboard.stats.completed': 'पूर्ण',
  'dashboard.stats.not_started': 'प्रारंभ नहीं हुआ',
  'dashboard.facts.time_limit': 'समय सीमा',
  'dashboard.facts.mins': 'मिनट',
  'dashboard.facts.attempts': 'प्रयास',
  'dashboard.facts.pass_benchmark': 'पास बेंचमार्क',
  'dashboard.facts.benchmark': 'बेंचमार्क',
  'dashboard.facts.attempt_progress': 'प्रयास प्रगति',
  'dashboard.actions.briefing_and_start': 'ब्रीफिंग और प्रारंभ करें →',
  'dashboard.actions.resume_attempt': 'प्रयास पुनः आरंभ करें →',
  'dashboard.actions.view_scorecard': 'स्कोरकार्ड देखें',
  'dashboard.actions.max_attempts_reached': 'अधिकतम प्रयास पूर्ण',
  'dashboard.actions.available_soon': 'शीघ्र उपलब्ध',
  'dashboard.actions.simulation_closed': 'सिमुलेशन बंद',
  'dashboard.actions.briefing': 'ब्रीफिंग →',
  'dashboard.actions.resume': 'जारी रखें',
  'dashboard.actions.scorecard': 'स्कोरकार्ड',

  // Status Labels
  'status.not_started': 'प्रारंभ नहीं हुआ',
  'status.in_progress': 'प्रगति पर',
  'status.completed': 'पूर्ण',
  'status.assigned': '★ असाइन किया गया',
  'status.ready_to_practice': 'अभ्यास के लिए तैयार',
  'status.passed': 'उत्तीर्ण',
  'status.not_passed': 'अनुत्तीर्ण',
  'status.paused': 'रोक दिया गया',
  'status.evaluated': 'मूल्यांकित',
  'status.expired': 'समाप्त',
  'status.abandoned': 'छोड़ा गया',
  'status.unknown': 'अज्ञात',

  // Attempts Stats & Actions
  'attempts.stats.total_attempts': 'कुल प्रयास',
  'attempts.stats.expired_inactive': 'समाप्त / निष्क्रिय',
  'attempts.loading_title': 'अभ्यास प्रयास लोड हो रहे हैं...',
  'attempts.loading_desc': 'सिमुलेशन सत्र, प्रयास परिणाम और ऐतिहासिक अभ्यास लॉग प्राप्त किए जा रहे हैं।',
  'attempts.no_attempts_title': 'मापदंड से मेल खाने वाला कोई प्रयास नहीं',
  'attempts.no_attempts_filter_hint': 'अपनी खोज क्वेरी और स्थिति फ़िल्टर बदलने या साफ़ करने का प्रयास करें।',
  'attempts.no_attempts_empty_hint': 'आपने अभी तक कोई सिमुलेशन प्रयास शुरू नहीं किया है। अभ्यास शुरू करने के लिए कैटलॉग से एक परिदृश्य चुनें।',
  'attempts.start_scenario_cta': 'एक परिदृश्य शुरू करें',
  'attempts.pagination_label': 'प्रयास',
  'attempts.tabs.all': 'सभी प्रयास',
  'attempts.admin_ledger_badge': '🛡️ एडमिन प्रयास लेजर',
  'attempts.all_organizations': '🏢 सभी संगठन (वैश्विक)',
  'attempts.search_organization_placeholder': 'नाम या स्लग द्वारा संगठन खोजें…',
  'attempts.no_organizations_match': 'कोई भी संगठन "{{query}}" से मेल नहीं खाता',
  'attempts.view_scope_label': 'देखने का दायरा:',
  'attempts.all_learners': '👥 सभी शिक्षार्थी',
  'attempts.my_own_attempts': '👤 मेरे अपने प्रयास',
  'attempts.search_learner_placeholder': 'नाम या ईमेल द्वारा शिक्षार्थी खोजें…',
  'attempts.learners_in_scope': 'दायरे में शिक्षार्थी ({{count}})',
  'attempts.no_learners_match': 'कोई भी शिक्षार्थी "{{query}}" से मेल नहीं खाता',
  'attempts.loading_attempts': 'सिमुलेशन प्रयास लोड हो रहे हैं...',
  'attempts.showing_count': '{{count}} सिमुलेशन प्रयास दिखा रहे हैं',
  'attempts.showing_count_plural': '{{count}} सिमुलेशन प्रयास दिखा रहे हैं',
  'attempts.search_placeholder': 'परिदृश्य खोजें...',
  'attempts.meta.attempt': 'प्रयास',
  'attempts.meta.difficulty': 'कठिनाई',
  'attempts.meta.date': 'दिनांक',
  'attempts.meta.evaluation': 'मूल्यांकन',
  'attempts.meta.not_started': 'प्रारंभ नहीं हुआ',
  'attempts.view_scorecard': 'स्कोरकार्ड देखें →',
  'attempts.view_attempt': 'प्रयास देखें →',
  'attempts.all_attempts_link': 'सभी प्रयास',
  'attempts.progress.turns': 'वार्तालाप चरण प्रगति',
  'attempts.progress.turns_unit': 'टर्न',
  'attempts.progress.elapsed_time': 'बीता हुआ समय',
  'attempts.action.resuming': 'पुनः शुरू हो रहा है...',
  'attempts.action.resume_simulation': 'सिमुलेशन पुनः शुरू करें',
  'attempts.err_resume_failed': 'प्रयास पुनः शुरू करने में विफल',
  'attempts.action.starting': 'शुरू हो रहा है...',
  'attempts.action.retry_attempt': 'पुनः प्रयास करें',
  'attempts.action.quota_exhausted': 'कोटा समाप्त',
  'attempts.action.attempts_left': 'शेष',
  'attempts.action.attempts_remaining': '{{count}} प्रयास शेष',
  'attempts.action.quota_reached': 'प्रयास कोटा पूर्ण हो गया',
  'attempts.action.retry_simulation': 'सिमुलेशन पुनः प्रयास करें',
  'attempts.meta.quota': 'कोटा',
  'attempts.meta.of': 'में से',
  'attempts.history_title_default': 'परिदृश्य प्रयास इतिहास',
  'attempts.history_subtitle': 'इस परिदृश्य के सभी दर्ज प्रयास और प्रगति प्रदर्शित की जा रही है।',
  'attempts.history_quota_used': '{{max}} में से {{used}} उपयोग किए गए ({{remaining}} शेष)',

  // Attempts Strip (Results & Key Moments)
  'attempts.strip.your_attempts': 'आपके प्रयास',
  'attempts.strip.used_of_total': '{{total}} में से {{used}} उपयोग किए गए',
  'attempts.strip.best_counts': 'सर्वश्रेष्ठ स्कोर परिणाम में गिना जाता है',
  'attempts.strip.attempt_n': 'प्रयास {{n}}',
  'attempts.strip.best': 'सर्वश्रेष्ठ',
  'attempts.strip.viewing': 'देख रहे हैं',
  'attempts.strip.available': 'उपलब्ध',
  'attempts.strip.passed': '✓ उत्तीर्ण',
  'attempts.strip.needs_review': '✕ समीक्षा आवश्यक',
  'attempts.strip.view_details': 'विवरण देखें →',
  'attempts.strip.take_attempt': 'प्रयास शुरू करें',

  // Pagination
  'pagination.showing': 'कुल {{total}} {{items}} में से {{start}}–{{end}} प्रदर्शित',
  'pagination.per_page': 'प्रति पृष्ठ:',
  'pagination.previous': '‹ पिछला',
  'pagination.next': 'अगला ›',
  'pagination.page_aria': 'पृष्ठ {{page}}',
  'pagination.prev_aria': 'पिछला पृष्ठ',
  'pagination.next_aria': 'अगला पृष्ठ',
  'pagination.select_per_page_aria': 'प्रति पृष्ठ आइटम चुनें',
  'pagination.nav_aria': 'पृष्ठांकन',

  // Difficulty & Category
  'difficulty.beginner': 'शुरुआती',
  'difficulty.intermediate': 'मध्यवर्ती',
  'difficulty.advanced': 'उन्नत',
  'difficulty.standard': 'मानक',
  'category.customer_service': 'ग्राहक सेवा',
  'category.sales': 'बिक्री',
  'category.compliance': 'अनुपालन',
  'category.de_escalation': 'विवाद समाधान',
  'category.coaching': 'प्रशिक्षण',
  'category.general_scenario': 'सामान्य परिदृश्य',

  // Common Labels
  'common.organization_label': 'संगठन:',
  'common.attempts': 'प्रयास',
  'nav.explore_scenarios': 'परिदृश्य देखें',
  'nav.learner_portal': 'शिक्षार्थी पोर्टल',

  // Admin Overview KPI Stats
  'admin.stats.total_organizations': 'कुल क्लाइंट संगठन',
  'admin.stats.active_subscriptions': 'सक्रिय एंटरप्राइज़ सदस्यताएँ',
  'admin.stats.active_workspaces': 'सक्रिय वर्कस्पेस',
  'admin.stats.live_proctoring': 'लाइव और प्रॉक्टरिंग सक्षम',
  'admin.stats.org_members': 'संगठन के सदस्य',
  'admin.stats.active_seats': 'सक्रिय शिक्षार्थी सीटें',
  'admin.stats.active_accounts': 'सक्रिय खाते',
  'admin.stats.compliant_sso': 'अनुपालन एवं एसएसओ सत्यापित',
  'admin.stats.published_cases': 'प्रकाशित सिमुलेशन केस',
  'admin.stats.total_authored_cases': 'कुल रचित केस',
  'admin.stats.ai_health': 'एआई इंजन स्थिति',
  'admin.stats.operational_100': '100% क्रियाशील',
  'admin.stats.models_online': 'संवाद और रूब्रिक मॉडल ऑनलाइन',

  // Admin Navigation Sections & Cards
  'admin.nav_section.org_governance': 'संगठन एवं एक्सेस गवर्नेंस',
  'admin.nav_section.training_analytics': 'प्रशिक्षण एनालिटिक्स एवं रिपोर्टिंग',
  'admin.nav_section.ai_studio': 'एआई सिमुलेशन एवं रूब्रिक्स स्टूडियो',
  'admin.nav_section.customization': 'अनुकूलन एवं कॉन्फ़िगरेशन',
  'admin.nav.org_management': 'संगठन प्रबंधन',
  'admin.nav.org_management_desc': 'क्लाइंट टेनेंट्स, ब्रांड दिशानिर्देश, डोमेन और वैश्विक सीमाएं प्रावधान और कॉन्फ़िगर करें।',
  'admin.nav.user_management': 'उपयोगकर्ता एवं भूमिका प्रबंधन',
  'admin.nav.user_management_desc': 'शिक्षार्थी खाते प्रबंधित करें, प्रशिक्षक अनुमतियां असाइन करें और बैचों की देखरेख करें।',
  'admin.nav.security_audit': 'सुरक्षा एवं ऑडिट लॉग',
  'admin.nav.security_audit_desc': 'अपरिवर्तनीय अनुपालन घटनाओं, प्रशासनिक परिवर्तनों और लॉगिन इतिहास का निरीक्षण करें।',
  'admin.nav.llm_audit': 'एलएलएम निष्पादन एवं टोकन ऑडिट ट्रेल',
  'admin.nav.llm_audit_desc': 'एलएलएम प्रॉम्प्ट, टोकन खपत, मॉडल विलंबता और लागत का ऑडिट करें।',
  'admin.nav.subscription_packages': 'सब्सक्रिप्शन पैकेज एवं ऑर्डर',
  'admin.nav.subscription_packages_desc': 'सास पैकेज, क्रेडिट कोटा और टेनेंट ऐड-ऑन ऑर्डर कॉन्फ़िगर करें।',
  'admin.nav.billing': 'सब्सक्रिप्शन, क्रेडिट एवं ऐड-ऑन',
  'admin.nav.billing_desc': 'सिमुलेशन क्रेडिट बैलेंस, रोलओवर स्थिति ट्रैक करें और ऐड-ऑन ऑर्डर करें।',
  'admin.nav.training_analytics': 'एंटरप्राइज़ प्रशिक्षण एनालिटिक्स',
  'admin.nav.training_analytics_desc': 'रीयल-टाइम सिमुलेशन पूर्णता मेट्रिक्स, योग्यता पास दर और बहु-टेनेंट प्रदर्शन।',
  'admin.nav.reports': 'सिमुलेशन एवं योग्यता रिपोर्ट',
  'admin.nav.reports_desc': 'संगठन पास दर, योग्यता बेंचमार्क बार और शिक्षार्थी मेट्रिक्स की समीक्षा करें।',
  'admin.nav.scenario_studio': 'परिदृश्य एवं केस स्टूडियो',
  'admin.nav.scenario_studio_desc': 'सिमुलेशन केस, ग्राहक व्यक्तित्व और योग्यता रूब्रिक्स लिखें और प्रकाशित करें।',
  'admin.nav.evaluation_studio': 'एआई मूल्यांकन स्टूडियो',
  'admin.nav.evaluation_studio_desc': 'मूल्यांकन रूब्रिक्स, स्कोरिंग प्रॉम्प्ट और प्रकाशन जीवनचक्र कॉन्फ़िगर करें।',
  'admin.nav.llm_vault': 'एआई प्रदाता एवं एलएलएम कुंजी वॉल्ट',
  'admin.nav.llm_vault_desc': 'संवाद एलएलएम, स्कोरिंग इंजन, वॉइस मॉडल और एन्क्रिप्टेड एपीआई कुंजियां कॉन्फ़िगर करें।',
  'admin.nav.udf': 'शिक्षार्थी कस्टम फ़ील्ड (UDF) एवं मैपिंग',
  'admin.nav.udf_desc': 'शिक्षार्थी मेटाडेटा फ़ील्ड्स (क्षेत्र, लागत केंद्र), सीएसवी सत्यापन और मैपिंग कॉन्फ़िगर करें।',
  'admin.nav.notifications': 'अधिसूचना एवं ईमेल सेटिंग्स',

  // Reports Filters
  'reports.filters': 'फ़िल्टर',
  'reports.filter_simulation': 'सिमुलेशन:',
  'reports.select_simulation': 'सिमुलेशन चुनें…',
  'reports.search_sim_placeholder': 'सिमुलेशन शीर्षक, श्रेणी, आईडी खोजें...',
  'reports.no_sims_found': 'कोई सिमुलेशन नहीं मिला',
  'reports.filter_organization': 'संगठन:',
  'reports.all_organizations': 'सभी संगठन',
  'reports.search_org_placeholder': 'संगठन का नाम, आईडी, स्लग खोजें...',
  'reports.all_orgs_cross_tenant': '🌐 सभी संगठन (क्रॉस-टेनेंट)',
  'reports.no_orgs_found': 'कोई संगठन नहीं मिला',
  'reports.filter_team': 'टीम:',
  'reports.filter_designation': 'पदनाम:',
  'reports.filter_region': 'क्षेत्र:',
  'reports.filter_result': 'परिणाम:',
  'reports.all_results': 'सभी परिणाम',
  'reports.clear_filters': 'साफ़ करें',

  // Scenario Buttons & Details
  'scenarios.back_to_scenarios': '← परिदृश्यों पर वापस जाएं',
  'scenarios.assign_learners': 'शिक्षार्थी असाइन करें',
  'scenarios.organization_access': 'संगठन पहुंच',
  'scenarios.duplicate': 'डुप्लिकेट बनाएं',
  'scenarios.llm_prompts': 'एलएलएम मूल्यांकन प्रॉम्प्ट',
  'scenarios.edit_scenario': 'परिदृश्य संपादित करें',
  'scenarios.learners_assigned': 'शिक्षार्थी असाइन किए गए',
  'scenarios.create_scenario': 'परिदृश्य बनाएं',
  'scenarios.category': 'श्रेणी:',
  'scenarios.difficulty': 'कठिनाई:',
  'scenarios.difficulty_label': 'कठिनाई',
  'scenarios.revert_draft': 'ड्राफ्ट पर वापस जाएं',
  'scenarios.publish_scenario': 'परिदृश्य प्रकाशित करें',
  'scenarios.publish_and_assign': '🚀 प्रकाशित करें और सौंपें',
  'scenarios.archive': 'संग्रहीत करें',
  'scenarios.start_simulation': 'सिमुलेशन शुरू करें',
  'scenarios.loading_dossier': 'परिदृश्य डोजियर लोड हो रहा है…',
  'scenarios.not_found': 'परिदृश्य नहीं मिला',
  'scenarios.download_template': 'टेम्पलेट डाउनलोड करें',
  'scenarios.import_json': 'JSON आयात करें',
  'scenarios.back_to_simulations': 'सिमुलेशन पर वापस जाएं',
  'scenarios.your_role': 'आपकी भूमिका',
  'briefing.enter_room': 'सिमुलेशन कक्ष में प्रवेश करें →',
  'briefing.launching': 'सिमुलेशन शुरू हो रहा है…',
  'briefing.resuming': 'सिमुलेशन फिर से शुरू हो रहा है…',
  'briefing.loading': 'परिदृश्य ब्रीफिंग डॉसियर लोड हो रहा है…',
  'briefing.error_title': 'परिदृश्य लोड करने में असमर्थ',
  'briefing.back_to_dashboard': '← डैशबोर्ड पर वापस जाएं',
  'briefing.default_role': 'ग्राहक सहायता प्रतिनिधि',
  'briefing.background_mission_title': 'परिदृश्य पृष्ठभूमि एवं शिक्षार्थी मिशन',
  'briefing.key_mission_label': 'मुख्य मिशन',
  'briefing.default_mission': 'ग्राहक के तनाव को शांत करें, उनकी मुख्य आवश्यकता को समझें, और अनुपालन मानकों के अनुसार समस्या का समाधान करें।',
  'briefing.persona_dossier_title': 'ग्राहक प्रोफ़ाइल डॉसियर',
  'briefing.personas_dossier_title_plural': 'परिदृश्य व्यक्तित्व डॉसियर ({{count}} एआई सहभागी)',
  'briefing.persona_number': 'व्यक्तित्व #{{n}}',
  'briefing.persona_role_label': 'भूमिका:',
  'briefing.persona_temperament_label': 'स्वभाव:',
  'briefing.persona_role_participant': 'सहभागी',
  'briefing.persona_temperament_challenging': 'चुनौतीपूर्ण / अतिआवश्यक',
  'briefing.competency_matrix_title': 'मूल्यांकन योग्यता मैट्रिक्स',
  'briefing.rubric_weight': 'भार',
  'briefing.rubric_empathy': 'सहानुभूति एवं सक्रिय श्रवण',
  'briefing.rubric_resolution': 'समस्या समाधान',
  'briefing.rubric_compliance': 'अनुपालन एवं प्रोटोकॉल',
  'briefing.rules_title': 'कार्यप्रणाली के नियम',
  'briefing.rule1_title': 'प्राकृतिक आवाज़ में संवाद आवश्यक',
  'briefing.rule1_desc': 'स्पष्ट रूप से बोलें जैसे आप किसी वास्तविक ग्राहक वॉइस कॉल पर बात करते हैं।',
  'briefing.rule2_title': 'रीयल-टाइम इंटरएक्टिव एआई',
  'briefing.rule2_desc': 'एआई व्यक्तित्व आपके प्रश्नों और सहानुभूति के आधार पर गतिशील रूप से प्रतिक्रिया देगा।',
  'briefing.rule3_title': 'गोपनीयता एवं वीडियो टेलीमेट्री',
  'briefing.rule3_desc': 'एआई कोचिंग और स्कोरिंग के लिए ऑडियो/वीडियो डेटा सुरक्षित रूप से संसाधित किया जाता है।',
  'briefing.language_title': 'भाषा चयन',
  'briefing.step_1': 'चरण 1',
  'briefing.select_language_desc': 'इस सिमुलेशन के लिए अपनी पसंदीदा वार्तालाप भाषा चुनें:',
  'briefing.select_language_aria': 'पसंदीदा वार्तालाप भाषा',
  'briefing.ready_badge': 'तैयार',
  'briefing.readiness_title': 'सिस्टम तत्परता',
  'briefing.step_2': 'चरण 2',
  'briefing.auto_diagnostics': 'स्वचालित परीक्षण जारी',
  'briefing.testing_button': 'परीक्षण…',
  'briefing.rerun_all': '↻ सभी पुनः चलाएँ',
  'briefing.optional_paren': '(वैकल्पिक)',
  'briefing.compulsory_paren': '(अनिवार्य)',
  'briefing.mic_subtext': 'ध्वनि इनपुट रिकॉर्डिंग',
  'briefing.camera_title': 'कैमरा एवं वीडियो',
  'briefing.camera_subtext': 'दृश्य ध्यान टेलीमेट्री',
  'briefing.speaker_title': 'स्पीकर प्लेबैक',
  'briefing.speaker_subtext': 'एआई ग्राहक व्यक्तित्व आवाज़',
  'briefing.sound_playing': '🔊 ध्वनि चल रही है…',
  'briefing.test_sound': '▶ ध्वनि परीक्षण',
  'briefing.network_title': 'नेटवर्क विलंबता',
  'briefing.network_subtext': 'एआई सर्वर कनेक्शन',
  'briefing.status.optional': 'वैकल्पिक',
  'briefing.status.checking': 'जाँच हो रही है…',
  'briefing.status.ready': '✓ तैयार',
  'briefing.status.testing': '⏳ परीक्षण जारी…',
  'briefing.status.optional_passed': '✓ वैकल्पिक',
  'briefing.status.failed': '⚠️ विफल',
  'briefing.status.pending': 'लंबित',
  'briefing.status.ok': '✓ ठीक',
  'briefing.allowance_reached_title': 'परिदृश्य प्रयास सीमा पूर्ण',
  'briefing.all_attempts_completed_title': 'सभी प्रयास पूर्ण हुए',
  'briefing.allowance_reached_desc_with_total': 'इस परिदृश्य का प्रयास कोटा पूरी तरह से उपयोग हो चुका है ({{total}} में से {{count}})। अतिरिक्त प्रयासों के लिए अपने व्यवस्थापक से संपर्क करें।',
  'briefing.allowance_reached_desc': 'इस परिदृश्य का प्रयास कोटा पूरी तरह से उपयोग हो चुका है। अतिरिक्त प्रयासों के लिए अपने व्यवस्थापक से संपर्क करें।',
  'briefing.max_attempts_reached_desc': 'आप इस सिमुलेशन के लिए अधिकतम अनुमत प्रयासों ({{max}} में से {{used}} पूर्ण) तक पहुँच चुके हैं। अब कोई अतिरिक्त प्रयास शुरू नहीं किया जा सकता।',
  'briefing.allowance_reached_btn': 'प्रयास सीमा पूर्ण',
  'briefing.max_attempts_reached_btn': 'अधिकतम प्रयास पूर्ण ({{used}}/{{max}})',
  'briefing.view_past_scorecards': 'पिछले प्रयास स्कोरकार्ड देखें →',
  'briefing.active_attempt_title': 'सक्रिय प्रयास प्रगति पर है',
  'briefing.active_attempt_desc': 'आपका एक सक्रिय प्रयास{{attempt}} पहले से प्रगति पर है। डुप्लिकेट प्रयासों की अनुमति नहीं है। आप सीधे अपना सत्र फिर से शुरू कर सकते हैं।',
  'briefing.active_attempt_number_tag': ' (प्रयास #{{n}})',
  'briefing.resume_in_progress': 'प्रगति पर प्रयास फिर से शुरू करें →',
  'briefing.consent_text': 'मैं मूल्यांकन रिकॉर्डिंग नीति से सहमत हूँ और एआई-आधारित वार्तालाप विश्लेषण और योग्यता मूल्यांकन की सहमति देता हूँ।',
  'briefing.view_terms': 'नियम एवं सहमति नीति देखें ↗',
  'briefing.running_hardware_checks': 'आवश्यक हार्डवेयर परीक्षण चल रहे हैं। इनके पास होते ही कमरा अनलॉक हो जाएगा।',
  'briefing.complete_system_checks': 'कमरा अनलॉक करने के लिए ऊपर दिए गए आवश्यक सिस्टम परीक्षण पूरे करें। विफल परीक्षण पुनः चलाएँ।',
  'briefing.consent_required_btn': 'कक्ष में प्रवेश के लिए सहमति आवश्यक',
  'briefing.checking_hardware_btn': 'हार्डवेयर की जाँच हो रही है…',
  'briefing.complete_checks_btn': 'सिस्टम परीक्षण पूर्ण करें',
  'briefing.start_note': 'कक्ष में प्रवेश करते ही सिमुलेशन समय तुरंत शुरू हो जाएगा। ({{max}} में से {{remaining}} प्रयास शेष)',
  'briefing.start_simulation_aria': 'सिमुलेशन प्रारंभ करें',
  'briefing.launching_short': 'शुरू हो रहा है…',
  'briefing.attempt_in_progress_short': 'प्रयास प्रगति पर',
  'briefing.dock_step_consent': 'चरण 3 · सहमति आवश्यक',
  'briefing.dock_step_hardware': 'चरण 2 · हार्डवेयर परीक्षण',
  'briefing.dock_ready': 'शुरू करने के लिए तैयार',
  'briefing.dock_ready_to_resume': 'सत्र पुनः शुरू करने के लिए तैयार',
  'briefing.dock_attempts_left': '{{max}} में से {{remaining}} प्रयास शेष',
  'briefing.dock_resume_btn': 'प्रयास फिर से शुरू करें →',
  'briefing.dock_consent_btn': 'समीक्षा एवं सहमति ↓',
  'briefing.dock_checks_btn': 'परीक्षण पूरे करें ↓',
  'briefing.dock_enter_btn': 'कक्ष में प्रवेश करें →',
  'briefing.overlay_resuming_title': 'आपका सिमुलेशन फिर से शुरू हो रहा है…',
  'briefing.overlay_preparing_title': 'आपका सिमुलेशन कक्ष तैयार हो रहा है…',
  'briefing.overlay_desc': 'प्रयास बनाया जा रहा है, आपकी आवाज़ सेटिंग्स लॉक की जा रही हैं और परिदृश्य लोड हो रहा है। इसमें कुछ सेकंड लग सकते हैं — कृपया यह टैब खुला रखें।',
  'briefing.overlay_cancel': 'रद्द करें और यहीं रहें',

  // Scenario List Stats (admin-stats-grid)
  'scenarios.stats.total': 'कुल परिदृश्य',
  'scenarios.stats.total_sub': 'निर्मित सिमुलेशन मामले',
  'scenarios.stats.published': 'प्रकाशित और सक्रिय',
  'scenarios.stats.published_sub': 'शिक्षार्थी अभ्यास के लिए लाइव',
  'scenarios.stats.draft': 'ड्राफ्ट निर्माण में',
  'scenarios.stats.draft_sub': 'कॉन्फ़िगरेशन प्रगति पर है',

  // Analytics Stats (admin-stats-grid)
  'analytics.stats.total_attempts': 'कुल सिमुलेशन प्रयास',
  'analytics.stats.avg_score': 'औसत प्रवीणता स्कोर',
  'analytics.stats.avg_score_sub': 'सभी मूल्यांकित प्रयासों में',
  'analytics.stats.pass_rate': 'बेंचमार्क उत्तीर्ण दर',
  'analytics.stats.pass_rate_sub': 'मानक सीमा बेंचमार्क: 70%',
  'analytics.stats.active_scenarios': 'सक्रिय परिदृश्य',
  'analytics.stats.total_scenarios_sub': 'कुल डिज़ाइन किए गए मामले',

  // Audit Log Stats (admin-stats-grid)
  'audit.stats.total_events': 'कुल रिकॉर्ड किए गए ईवेंट',
  'audit.stats.successful_auth': 'सफल प्राधिकरण',
  'audit.stats.user_mutations': 'उपयोगकर्ता और भूमिका परिवर्तन',
  'audit.stats.scenario_ops': 'परिदृश्य संचालन',

  // Tenant Details Stats (admin-stats-grid)
  'tenant.stats.users': 'उपयोगकर्ता',
  'tenant.stats.scenarios': 'परिदृश्य',
  'tenant.stats.attempts_run': 'चलाए गए प्रयास',

  // Video Observations Extended
  'scorecard.face_centering': 'चेहरा केंद्रीकरण (फ़्रेमिंग)',
  'scorecard.sampled_frames': 'नमूनाकृत फ्रेम्स',
  'scorecard.model_confidence': 'मॉडल विश्वसनीयता',
  'scorecard.missing_intervals': '{{count}} अनुपस्थित अंतराल',
  'scorecard.framing_alignment': 'फ़्रेमिंग ज़ोन संरेखण',
  'scorecard.optimal_positioning': 'इष्टतम कैमरा स्थिति',
  'scorecard.framing_omitted': 'फ़्रेमिंग टेलीमेट्री छोड़ी गई',
  'scorecard.valid_samples': '100% मान्य नमूने',
  'scorecard.failed_samples': '{{count}} विफल नमूने',
  'scorecard.detection_certainty': 'पहचान निश्चितता',
  'scorecard.no_face_intervals': 'चेहरा अनुपस्थित अंतराल ({{count}})',
  'scorecard.no_face_desc': 'वे अंतराल जब शिक्षार्थी कैमरे के फ्रेम से बाहर था',
  'scorecard.interval_num': 'अंतराल #{{num}}: {{start}} – {{end}}',
  'scorecard.duration_sec': '{{sec}}s अवधि',
  'scorecard.warning_tag': '(चेतावनी)',
  'scorecard.head_pose_title': 'सिर की दिशा/मुद्रा अवलोकन',
  'scorecard.supported': 'समर्थित',
  'scorecard.unsupported': 'असमर्थित',
  'scorecard.within_limits': 'सीमाओं के भीतर',
  'scorecard.avg_angles': 'औसत यॉ / पिच / रोल',
  'scorecard.max_rotation': 'अधिकतम घूर्णन',
  'scorecard.facial_expressions_title': 'अनुमानित चेहरे के भाव (face-api.js)',
  'scorecard.on_device_outputs': 'ऑन-डिवाइस मॉडल परिणाम',
  'scorecard.assessment_integrity_notice': 'मूल्यांकन सत्यनिष्ठा सूचना: भौतिक कैमरा मेट्रिक्स कैमरा फ़्रेमिंग और ऑन-डिवाइस पहचान विश्वास को दर्शाते हैं। ये केवल अवलोकन संदर्भ के रूप में प्रदान किए जाते हैं और संवादी योग्यता अंकों को नहीं बदलते हैं।',
  'scorecard.telemetry_not_recorded': 'इस सत्र के दौरान वीडियो टेलीमेट्री रिकॉर्ड नहीं की गई थी (केवल माइक्रोफ़ोन ऑडियो)। दृश्य मेट्रिक्स जैसे फ़्रेमिंग और फेस सेंटरिंग को आपकी योग्यता स्कोर पर बिना किसी दंड के इस स्कोरकार्ड से बाहर रखा गया है।',
  'scorecard.audio_recorded_evaluated': 'ऑडियो रिकॉर्ड और मूल्यांकित',
  'scorecard.verbal_competency_intact': 'मौखिक योग्यता अक्षुण्ण',
  'scorecard.retrieving_telemetry': 'वीडियो साक्ष्य टेलीमेट्री प्राप्त की जा रही है...',
  'scorecard.video_failed_desc': 'इस प्रयास के लिए वीडियो विश्लेषण पूरा नहीं किया जा सका।',
  'scorecard.head_pose_unsupported': 'हेड-पोज़ अनुमान असमर्थित है या डिटेक्टर से लैंडमार्क कोण अनुपलब्ध थे।',
  'scorecard.facial_notice': 'सूचना: चेहरे के भाव लेबल अनुमानित स्थानीय मॉडल अवलोकन हैं। वे संवाद मूल्यांकन से अलग हैं और सीधे योग्यता अंकों को बढ़ाते या घटाते नहीं हैं।',

  // Communication & Delivery Grid
  'scorecard.comm_delivery_title': 'संचार और प्रस्तुति',
  'scorecard.from_voice_and_transcript': 'आपकी आवाज़ और प्रतिलेख से',
  'scorecard.speaking_pace': 'बोलने की गति (Pace)',
  'scorecard.words_per_min': 'शब्द/मिनट',
  'scorecard.ideal_pace': '130 - 160 आदर्श',
  'scorecard.filler_words_title': 'पूरक शब्द और ठहराव (Fillers)',
  'scorecard.total_fillers': 'कुल · {{fpm}}/मिनट',
  'scorecard.view_evidence': '🔍 देखें',
  'scorecard.turn_taking_title': 'बारी लेने का संतुलन (Turn-taking)',
  'scorecard.learner_share': 'शिक्षार्थी',
  'scorecard.customer_share': 'ग्राहक',
  'scorecard.listening_ratio': 'सुनने का अनुपात',
  'scorecard.clarity_articulation': 'स्पष्टता और उच्चारण',
  'scorecard.response_latency': 'प्रतिक्रिया विलंबता (Latency)',
  'scorecard.interruptions_overlaps': 'भाषण ओवरलैप (Interruptions)',
  'scorecard.emotional_tone': 'भावनात्मक स्वर',
  'scorecard.energy_engagement': 'ऊर्जा और जुड़ाव',
  'scorecard.status_good': 'अच्छा',
  'scorecard.status_watch': 'ध्यान दें',
  'scorecard.status_needs_work': 'सुधार की आवश्यकता',

  // Replay & Key Moments Card
  'scorecard.replay_moments_title': 'रीप्ले और मुख्य क्षण',
  'scorecard.replay_moments_subtitle': 'संवादात्मक प्लेबैक और कोचिंग युक्तियों के साथ अपनी बातचीत के महत्वपूर्ण मोड़ों की समीक्षा करें',
  'scorecard.waveform_mode': 'वेवफ़ॉर्म',
  'scorecard.video_player_mode': 'वीडियो प्लेयर',
  'scorecard.filter_all': 'सभी क्षण ({{count}})',
  'scorecard.filter_improvement': 'सुधार की आवश्यकता',
  'scorecard.filter_strength': 'मजबूती / ताकत',
  'scorecard.ai_customer': 'एआई ग्राहक',
  'scorecard.learner_you': 'आप (शिक्षार्थी)',
  'scorecard.play_moment': 'क्षण चलाएं',
  'scorecard.pause_moment': 'रोकें',
  'scorecard.jump_to_moment': 'इस क्षण पर जाएं',
  'scorecard.coach_recommendation': 'कोच की सिफारिश',
  'scorecard.targeted_drill': 'लक्षित माइक्रो-ड्रिल',
  'scorecard.practice_drill': 'इस मोड़ का अभ्यास करें',
  'scorecard.customer_prompt': 'ग्राहक का वक्तव्य',
  'scorecard.what_you_said': 'आपने क्या कहा',
  'scorecard.speed_1x': '1.0x',
  'scorecard.speed_125x': '1.25x',
  'scorecard.speed_15x': '1.5x',
  'scorecard.no_moments_found': 'इस फ़िल्टर के लिए कोई मुख्य क्षण रिकॉर्ड नहीं किए गए।',

  // Conversation Transcript Card
  'scorecard.transcript_title': 'बातचीत का प्रतिलेख (Transcript)',
  'scorecard.transcript_sub': 'शब्दानुश शब्द वार्तालाप लोड करने के लिए क्लिक करें',
  'scorecard.show_transcript': 'प्रतिलेख दिखाएं',
  'scorecard.hide_transcript': 'प्रतिलेख छुपाएं',
  'scorecard.all_turns': 'सभी मोड़ ({{count}})',
  'scorecard.learner_turns': 'शिक्षार्थी ({{count}})',
  'scorecard.ai_turns': 'एआई व्यक्तित्व ({{count}})',
  'scorecard.open_full_modal': 'पूर्ण मोडल में खोलें ↗',
  'scorecard.turn_n': 'मोड़ #{{n}}',
  'scorecard.empty_turns_filter': 'इस फ़िल्टर के लिए कोई बातचीत दर्ज नहीं की गई।',

  // Transcript Viewer Modal
  'scorecard.modal_transcript_title': 'संवाद संचार प्रतिलेख',
  'scorecard.modal_transcript_sub': 'लाइव सिमुलेशन के दौरान रिकॉर्ड किए गए शब्दशः संवाद',
  'scorecard.copy_transcript_text': '📋 टेक्स्ट कॉपी करें',
  'scorecard.transcript_copied': '✓ कॉपी हो गया',
  'scorecard.close_modal': 'बंद करें',
  'scorecard.total_turns_count': 'कुल संवाद मोड़: {{count}}',

  // Inspect Prompts Modal
  'scorecard.inspect_prompts_title': 'एलएलएम प्रॉम्प्ट और साक्ष्य का निरीक्षण',
  'scorecard.inspect_prompts_sub': 'एलएलएम मूल्यांकक को भेजे गए अंतर्निहित सिस्टम प्रॉम्प्ट, इनपुट ट्रांसक्रिप्ट और रूब्रिक मानदंडों का ऑडिट करें',
  'scorecard.tab_input_data': '📥 एलएलएम को इनपुट डेटा ({{count}} मोड़)',
  'scorecard.tab_system_instruction': 'सिस्टम निर्देश',
  'scorecard.tab_evaluated_rubrics': 'मूल्यांकित रूब्रिक्स ({{count}})',
  'scorecard.tab_raw_response': 'कच्चा JSON आउटपुट',
  'scorecard.copy_prompts_json': '📋 प्रॉम्प्ट JSON कॉपी करें',
  'scorecard.prompts_copied': '✓ JSON कॉपी हो गया',
  'scorecard.eval_provider_label': 'मूल्यांकन प्रदाता:',

  // Evaluation Status & Result Error
  'scorecard.scoring_dialogue_title': 'सिमुलेशन संवाद का स्कोरिंग जारी है…',
  'scorecard.eval_processing_title': 'मूल्यांकन प्रसंस्करण',
  'scorecard.eval_processing_desc': 'एआई मूल्यांकन इंजन सक्षमता रूब्रिक्स और साक्ष्य बेंचमार्क के विरुद्ध आपके वार्तालाप ट्रांसक्रिप्ट का विश्लेषण कर रहा है।',
  'scorecard.evaluating_in_progress': 'ट्रांसक्रिप्ट का मूल्यांकन किया जा रहा है...',
  'scorecard.check_status_btn': 'मूल्यांकन स्थिति जांचें',
  'scorecard.error_results_unavailable': 'मूल्यांकन परिणाम अनुपलब्ध',
  'scorecard.error_default_msg': 'इस प्रयास के लिए मूल्यांकन परिणाम प्राप्त नहीं किए जा सके। कृपया अपना नेटवर्क कनेक्शन जांचें और पुनः प्रयास करें।',
  'scorecard.my_attempts_nav': 'मेरे प्रयास',
  'scorecard.scoring_evaluating_msg': 'आपके प्रयास के प्रदर्शन का स्कोरिंग और मूल्यांकन किया जा रहा है...',
  'scorecard.results_generating_msg': 'प्रयास मूल्यांकन परिणाम तैयार किए जा रहे हैं...',
};

